// Ленивые разделы публичного сайта. Загрузчики общие для React.lazy и
// предзагрузки: повторный import() отдаёт уже скачанный модуль.

import { prefetchLatestNews } from '../page/latestnews/LatestNews';
import { prefetchFaq } from '../page/faq/Faq';

export const loadDonate      = () => import('../page/donate/Donate');
export const loadRules       = () => import('../page/rules/Rules');
export const loadPublicPage  = () => import('../page/pages/PublicPage');
export const loadNewsList    = () => import('../page/news/NewsList');
export const loadNewsArticle = () => import('../page/news/NewsArticle');

let preloaded = false;

/** Скачать разделы в фоне, когда браузер свободен (после загрузки главной). */
export function preloadPublicRoutes(): void {
  if (preloaded) return;
  preloaded = true;
  const run = () => {
    [loadDonate, loadRules, loadNewsList, loadNewsArticle, loadPublicPage]
      .forEach((load) => { load().catch(() => { preloaded = false; }); });
    // Данные главной (новости, FAQ): при переходе на неё экраны и точки
    // справа появляются сразу, а не догружаются на глазах
    prefetchLatestNews();
    prefetchFaq();
  };
  const idle = (window as Window & { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number })
    .requestIdleCallback;
  const start = () => (idle ? idle(run, { timeout: 4000 }) : window.setTimeout(run, 1500));
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
}

/**
 * Путь — страница самого сайта (открывается без перезагрузки).
 * Остальное на том же домене (форум, /files, кабинет) — отдельные
 * приложения, их открываем обычным переходом.
 */
export const isSiteRoute = (path: string) =>
  /^\/($|donate\/?$|rules\/?$|news(\/|$)|pages\/)/.test(path);
